import React, { Component } from 'react';
import { Button, Paper, Grid, Modal } from '@material-ui/core';
import PropTypes from 'prop-types';

import Dropdown from '../FormInput/Dropdown';
import NumberInput from '../FormInput/NumberInput';

import { monthItems } from '../../constants/general';
import i18n from '../../i18n';

import '../../assets/stylesheets/Setting.css';

class AvailabilityRequestModal extends Component {
  constructor(props) {
    super(props);

    const { month, year } = props;

    this.state = {
      selectedMonth: month,
      selectedYear: year
    };
  }

  handleChange = event => {
    const {
      target: { name, value }
    } = event;

    this.setState({
      [name]: parseInt(value, 10)
    });
  };

  emailAvailabilityRequest = () => {
    const { selectedMonth, selectedYear } = this.state;
    const { handleRequestAvailability, toggleAvailabilityModal } = this.props;
    handleRequestAvailability(selectedMonth, selectedYear);
    toggleAvailabilityModal();
  };

  render() {
    const { selectedMonth, selectedYear } = this.state;
    const { showAvailabilityModal, toggleAvailabilityModal } = this.props;

    return (
      <Modal open={showAvailabilityModal} onClose={toggleAvailabilityModal}>
        <Paper className="deleteModal">
          <Grid container>
            <Grid item xs={12}>
              <h3>{i18n.t('availability:requestAvailability')}</h3>
            </Grid>
            <Grid item xs={12}>
              {i18n.t('availability:availabilityInstruction')}
            </Grid>

            <Grid item xs={2} />
            <Grid item xs={3}>
              <Dropdown
                options={monthItems}
                label={i18n.t('month')}
                onChange={this.handleChange}
                value={selectedMonth}
                name="selectedMonth"
              />
            </Grid>
            <Grid item xs={2} />
            <Grid item xs={3}>
              <NumberInput
                name="selectedYear"
                onChange={this.handleChange}
                value={selectedYear}
              />
            </Grid>
            <Grid item xs={2} />

            <Grid item xs={6}>
              <Button
                onClick={this.emailAvailabilityRequest}
                className="ssenseButton ssensePrimary"
                disabled={selectedYear === ''}
              >
                {i18n.t('confirm')}
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={toggleAvailabilityModal}
                className="ssenseButton ssenseDefault"
              >
                {i18n.t('cancel')}
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Modal>
    );
  }
}

AvailabilityRequestModal.propTypes = {
  showAvailabilityModal: PropTypes.bool.isRequired,
  toggleAvailabilityModal: PropTypes.func.isRequired,
  handleRequestAvailability: PropTypes.func.isRequired,
  month: PropTypes.number.isRequired,
  year: PropTypes.number.isRequired
};

export default AvailabilityRequestModal;
